// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image._zoomOverlay = overlay;

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';

    image._zoomInitialized = true;
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio, deltaX = 0, deltaY = 0) {
  const overlay = image._zoomOverlay;
  const zoomState = image._zoomState;

  if (!overlay || !zoomState) return;

  // calculate mouse position
  const ratio = image.height / image.width;
  let xPosition, yPosition;

  if (event.type === 'mousemove') {
    const container = image.getBoundingClientRect();
    xPosition = event.clientX - container.left;
    yPosition = event.clientY - container.top;

    zoomState.xPercent = (xPosition / image.clientWidth) * 100;
    zoomState.yPercent = (yPosition / (image.clientWidth * ratio)) * 100;

  } else {
    zoomState.xPercent = Math.max(0, Math.min(100, zoomState.xPercent + deltaX));
    zoomState.yPercent = Math.max(0, Math.min(100, zoomState.yPercent + deltaY));
  }

  overlay.style.backgroundPosition = `${zoomState.xPercent}% ${zoomState.yPercent}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
   if (image._zoomOverlay) return;

  const overlay = createOverlay(image);

  image._zoomState = {
    xPercent: 0,
    yPercent: 0,
    zoomRatio: zoomRatio
  };

  image._zoomOverlay = overlay;
  image._zoomInitialized = true;

  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    image._zoomOverlay = null;
    image._zoomState = null;
    image._zoomInitialized = false;
  };
}

function initTouchZoom(image, mediaContainer, swiperEl) {
  if (mediaContainer._touchZoomInitialized) return;
  mediaContainer._touchZoomInitialized = true;
  mediaContainer.style.touchAction = 'pan-y';

  const DOUBLE_TAP_ZOOM = 2.5;
  const MAX_ZOOM = 4;
  const DOUBLE_TAP_DELAY = 300;

  let scale = 1;
  let translateX = 0;
  let translateY = 0;
  let lastTapTime = 0;
  let isPinching = false;
  let initialPinchDist = 0;
  let initialPinchScale = 1;
  let isPanning = false;
  let panStartX = 0;
  let panStartY = 0;
  let panStartTranslateX = 0;
  let panStartTranslateY = 0;

  function getSwiper() {
    return swiperEl?.swiper;
  }

  function getTouchDistance(touches) {
    const dx = touches[1].clientX - touches[0].clientX;
    const dy = touches[1].clientY - touches[0].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getTouchMidpoint(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2,
    };
  }

  function clampTranslate(tx, ty, s) {
    const containerWidth = mediaContainer.offsetWidth;
    const containerHeight = mediaContainer.offsetHeight;
    const maxTx = (containerWidth * (s - 1)) / (2 * s);
    const maxTy = (containerHeight * (s - 1)) / (2 * s);
    return {
      x: Math.max(-maxTx, Math.min(maxTx, tx)),
      y: Math.max(-maxTy, Math.min(maxTy, ty)),
    };
  }

  function applyTransform() {
    const clamped = clampTranslate(translateX, translateY, scale);
    translateX = clamped.x;
    translateY = clamped.y;
    mediaContainer.style.transform = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;
  }

  function setTransition(on) {
    mediaContainer.style.transition = on ? 'transform 0.25s ease' : '';
  }

  function enterZoom(centerX, centerY, targetScale) {
    const rect = mediaContainer.getBoundingClientRect();
    const dx = centerX - (rect.left + rect.width / 2);
    const dy = centerY - (rect.top + rect.height / 2);
    translateX = -dx * (1 - 1 / targetScale);
    translateY = -dy * (1 - 1 / targetScale);
    scale = targetScale;

    setTransition(true);
    applyTransform();
    setTimeout(() => setTransition(false), 250);

    getSwiper()?.disable();
    image._touchZoomed = true;
  }

  function exitZoom() {
    scale = 1;
    translateX = 0;
    translateY = 0;

    setTransition(true);
    applyTransform();
    setTimeout(() => {
      setTransition(false);
      mediaContainer.style.transform = '';
    }, 250);

    getSwiper()?.enable();
    image._touchZoomed = false;
  }

  mediaContainer.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      const now = Date.now();
      if (now - lastTapTime < DOUBLE_TAP_DELAY) {
        e.preventDefault();
        if (image._touchZoomed) {
          exitZoom();
        } else {
          const touch = e.touches[0];
          enterZoom(touch.clientX, touch.clientY, DOUBLE_TAP_ZOOM);
        }
        lastTapTime = 0;
        return;
      }
      lastTapTime = now;

      if (image._touchZoomed) {
        isPanning = true;
        panStartX = e.touches[0].clientX;
        panStartY = e.touches[0].clientY;
        panStartTranslateX = translateX;
        panStartTranslateY = translateY;
      }
    } else if (e.touches.length === 2) {
      e.preventDefault();
      initialPinchDist = getTouchDistance(e.touches);
      initialPinchScale = scale;
      isPanning = false;
      isPinching = true;
    }
  }, { passive: false });

  mediaContainer.addEventListener('touchmove', (e) => {
    if (e.touches.length === 1 && isPanning) {
      e.preventDefault();
      e.stopPropagation();
      const dx = e.touches[0].clientX - panStartX;
      const dy = e.touches[0].clientY - panStartY;
      translateX = panStartTranslateX + dx / scale;
      translateY = panStartTranslateY + dy / scale;
      applyTransform();
    } else if (e.touches.length === 2 && isPinching) {
      e.preventDefault();
      e.stopPropagation();
      const dist = getTouchDistance(e.touches);
      let newScale = initialPinchScale * (dist / initialPinchDist);
      newScale = Math.max(1, Math.min(MAX_ZOOM, newScale));

      if (newScale <= 1) {
        exitZoom();
      } else {
        scale = newScale;
        applyTransform();
        if (!image._touchZoomed) {
          getSwiper()?.disable();
          image._touchZoomed = true;
        }
      }
    }
  }, { passive: false });

  mediaContainer.addEventListener('touchend', () => {
    isPinching = false;
    isPanning = false;
    if (scale <= 1.05 && image._touchZoomed) {
      exitZoom();
    }
  }, { passive: true });
}

function enableTouchZoom() {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    const mediaContainer = image.closest('.product-media-container');
    const swiperEl = image.closest('.product-media-gallery__main-slider');
    if (!mediaContainer || !swiperEl) return;
    initTouchZoom(image, mediaContainer, swiperEl);
  });
}

function enableZoomOnHover(zoomRatio) {
  // Touch devices (phones/tablets) can't hover — use touch zoom instead.
  if (window.matchMedia('(hover: none)').matches) {
    enableTouchZoom();
    return;
  }

  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.setAttribute('tabindex', '0');

    image.onmouseenter = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };

    image.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        magnify(image, zoomRatio);
      }

      if (event.key === 'Escape') {
        image._zoomOverlay?.remove();
        image._zoomOverlay = null;
        image._zoomState = null;
        image._zoomInitialized = false;
      }

      if (image._zoomOverlay && image._zoomInitialized) {
        const moveStep = 8;

        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, 0, -moveStep);
            break;
          case 'ArrowDown':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, 0, moveStep);
            break;
          case 'ArrowLeft':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, -moveStep, 0);
            break;
          case 'ArrowRight':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, moveStep, 0);
            break;
        }
      }

    });

  });
}

enableZoomOnHover(2);
